import React from 'react'
import css from './style.scss'
import {StatTitle} from './utils'
import cn from 'classnames'
import StoriesList from 'components/account_page/stories/list/index'
import StoryDetails from 'components/account_page/story_details/containers/stats';
import {Route} from 'react-router-dom';
import { n } from 'shared/numbers'

class BestDay extends React.Component{
  constructor(props){
    super(props)
    this.state={
      groupedStories:[],
      data:[],
      loaded:false
    }
  }
  componentDidMount(){
    this.loadStats(this.props)
  }
  componentWillReceiveProps(props){
    this.loadStats(props)
  }

  loadStats=(props)=>{
    if(props.data.length>0){
      let data=props.data.map(d=>{
        return {
          name:d.day.format("DD MMMM"),
          stories:d.stories,
          impressions:d.stories.reduce((acc,s)=>{
            return acc=acc+s.insights.impressions
          }, 0)
        }
      })
      let dayStories=data.reduce(function(prev, current) {
        return (prev.impressions > current.impressions) ? prev : current
      })
      this.setState({dayStories})
    }
  }

  render(){
    return (
      <div className={cn(this.props.className, css.statsBox)}>
        <StatTitle>Best Day</StatTitle>
        <Route path="/a/:id/stats/day/:storyId" render={routeProps=>(
          <StoryDetails {...routeProps}
          stories={this.state.dayStories.stories}/>
        )} />
        <div className={css.impressionsPerDayContainer}>
        {this.state.dayStories &&
          <div>
            {this.state.dayStories.stories.length > 0 &&
              <p><b>{this.state.dayStories.name}</b>, with <b>{n(this.state.dayStories.impressions)}</b> impressions</p>
            }
            {this.state.dayStories.stories.length === 0 &&
              <p>Try share more stories!</p>
            }
            <StoriesList
              onlyStories={true}
              baseName="/day"
              stories={this.state.dayStories.stories}
            />
          </div>
        }
        
        </div>
      </div>
    )
  }
}

export default BestDay;



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/bestDay.js